import React,{Component} from 'react';
import './home.scss';
import "../../../node_modules/video-react/dist/video-react.css"; // import css
import Loader from "../../components/Loader";
import ItemModality from "../../components/ItemModality";
import ItemContact from "../../components/ItemContact";
import anime from "animejs";
import Session from "../../sandbox/session";

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sendMail: false,
      viewCv: false,
      ifeSelect: false,
      isBusy: false,
      txtLoadContact: false,
      txtLoad1: false,
      txtLoad2: false,
      txtLoad3: false,
      txtLoad4: false,
      txtLoad5: false,
      txtLoad6: false
    };
    this.isBusy = false;
    this.firstTime = false;
  }

  UNSAFE_componentWillMount() {
    this.firstTime=Session.instance._firstTime;
  }

  componentDidMount() {
    if(!this.firstTime) {
      this.setState({
        txtLoadContact: true,
        txtLoad1: true,
        txtLoad2: true,
        txtLoad3: true,
        txtLoad4: true,
        txtLoad5: true,
        txtLoad6: true
      })
    }


  }

  componentWillUnmount() {
    Session.instance._firstTime = false;
    //localStorage.setItem("fi")
  }

  onLoadedView = () => {
    this.setState({isBusy:!this.state.isBusy});
    anime({
      targets: ['.body-home',],
      scale: ['0', '1'],
      duration: 1000,
      easing: 'easeInQuad',
    });
    setTimeout(()=>{
      this.setState({
        txtLoad1:true
      });
      setTimeout(()=>{
        this.setState({
          txtLoad2:true
        });
        setTimeout(()=>{
          this.setState({
            txtLoad3:true
          });
          setTimeout(()=>{
            this.setState({
              txtLoad4:true
            });
            setTimeout(()=>{
              this.setState({
                txtLoad5:true
              });

              setTimeout(()=>{
                this.setState({
                  txtLoad6:true
                });

                setTimeout(()=>{
                  this.setState({
                    txtLoadContact:true
                  });
                  if(this.firstTime) {
                    anime({
                      targets: ['.cnt-col2-row2',],
                      translationX: ["-30em", "0",],
                      borderRadius: '8px',
                      duration: 17000,
                      loop: false,
                      scale: [0, 1],
                    });
                  }

                }, 10000);
              }, 5000);
            }, 5000);
          }, 5000);
        }, 5000);
      }, 6000);
    }, 5000);
  }


  render() {
    const {state} = this;
    return this.isBusy ?
     <Loader required={this.firstTime} timeLoad={this.firstTime ? 6000 : 3500} onLoaded={this.onLoadedView} /> :
        <section className={"body-home"}>
          
          <div  className={"cnt-column2-home"}>
            {state.txtLoadContact && <ItemContact firstTime={this.firstTime}/>}
            <div className={"cnt-col2-row2"}>
              <div className={"cnt-col2-row2-col1"}>
                <div className={"item-cl2-rw2-cl1"}>
                  <p className={"txt-skill"}>|POLYVALENT</p>
                  <p className={"txt-skill"}>|TEAMPLAYER</p>
                  <p className={"txt-skill"}>|PROACTIVE</p>
                  <p className={"txt-skill"}>|ATTENTIVE</p>
                </div>
                <div className={"item-cl2-rw2-cl1"}>
                  <p className={"txt-skill"}>|AUTODIDACT</p>
                  <p className={"txt-skill"}>|QUICKLEARN</p>
                  <p className={"txt-skill"}>|ORGANIZED</p>
                </div>
                <div className={"item-cl2-rw2-cl1"}>
                  <p className={"txt-skill"}>|BROADMINDED</p>
                  <p className={"txt-skill"}>|CREATIVE</p>
                </div>
                <div className={"item-cl2-rw2-cl1"}>
                  <p className={"txt-skill"}>|CURIOUS</p>
                </div>
              </div>
              <div>

              {state.txtLoad1 && <div className={"txt-cl2-rw2"}>
                <p className={"txt-cl2-rw2"}>
                Gaviria IT Services, Investigation Culture, Bogota Colombia 🇨🇴
                </p>
              </div>}

              {
                state.txtLoad2 && <div className={"txt-cl2-rw2"}>
                  <p className={"m-nn"}>
                    We've extensive experience to systematize processes and / or needs of your company,
                  </p>
                </div>
              }
              {
                state.txtLoad3 && <div className={"txt-cl2-rw2"}>
                  <p className={"m-nn"}>
                     We are known for exceeding customer expectations.
                    <br/>
                    <br/>
                  </p>
                </div>
              }
              {
                state.txtLoad4 && <div className={"txt-cl2-rw2"}>
                  <p>
                    We seek a better tomorrow through a transformation of the world.
                  </p>
                </div>
              }
              {
                state.txtLoad5 &&
                <div className={"txt-cl2-rw2"}>
                  <p>
                    We are experts in providing infrastructure, infrastructure as code, continuous monitoring, performance testing, security testing, continuous deployments, continuous integrations and custom development
                  </p>
                </div>
              }
              {
                state.txtLoad6 &&
                <div className={"txt-cl2-rw2"}>
                  <p>
                    We love our world, we love challenges and systematizing processes is our favorite hobby.
                  </p>
                  <span className={"txt-cl2-rw2 aux-txt-rw2 fw-b"}>
                NO PAIN NO GAIN
                </span>
                </div>
              }
              </div>
            </div>
            <div className={"cnt-modalities"}>
            <ItemModality url={"#/Services"} title={"Services"} imageMod={require("../../rsc/assets/iconServices.svg")} />
            {/* <ItemModality url={"#/Experience"} title={"Experience"} imageMod={require("../../rsc/assets/iconExperience.svg")} /> */}
            <ItemModality url={"#/Tools"} title={"Tools"} imageMod={require("../../rsc/assets/iconTools.svg")} />
            <ItemModality url={"#/Advantages"} title={"Advantages"} imageMod={require("../../rsc/assets/iconAdvantages.svg")} />
          </div>
          </div>
        </section>;

  }

  sendMail = () => {
    window.open("mailto:cristian@gaviria.org");
    this.setState({
      infoContact: "cristian@gaviria.org"
    });
  }

}

export default Home;
